import React, { useEffect, useState } from 'react';
import sseService from '../services/sseService';
import './SSEConnectionStatus.css';

/**
 * Visual indicator for SSE connection status
 * Shows a small indicator in the corner of the screen
 */
const SSEConnectionStatus = () => {
  const [status, setStatus] = useState({
    isConnected: false,
    lastHeartbeat: null,
    reconnectAttempts: 0
  });
  const [showDetails, setShowDetails] = useState(false);
  // const [position, setPosition] = useState({ x: null, y: null });
  // const [isDragging, setIsDragging] = useState(false);
  // const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Update status every 5 seconds
    const updateStatus = () => {
      const currentStatus = sseService.getConnectionStatus();
      setStatus(currentStatus);
    };

    updateStatus();
    const interval = setInterval(updateStatus, 5000);

    // Listen to connection events
    const unsubscribeConnected = sseService.on('connected', updateStatus);
    const unsubscribeDisconnected = sseService.on('disconnected', updateStatus);
    const unsubscribeError = sseService.on('error', updateStatus);

    return () => {
      clearInterval(interval);
      unsubscribeConnected();
      unsubscribeDisconnected();
      unsubscribeError();
    };
  }, []);

  /*
  // Handle mouse down to start dragging
  const handleMouseDown = (e) => {
    if (e.button !== 0) return; // Only left click
    setIsDragging(true);
    
    const rect = e.currentTarget.getBoundingClientRect();
    setDragOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
  };

  // Handle mouse move during drag
  useEffect(() => {
    if (!isDragging) return;

    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX - dragOffset.x,
        y: e.clientY - dragOffset.y
      });
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, dragOffset]);
  */

  const getStatusColor = () => {
    if (status.isConnected) return '#10b981'; // green
    if (status.reconnectAttempts > 0) return '#f59e0b'; // orange
    return '#ef4444'; // red
  };

  const getStatusText = () => {
    if (status.isConnected) return 'Connected';
    if (status.reconnectAttempts > 0) return 'Reconnecting...';
    return 'Disconnected';
  };

  const containerStyle = {
    display: window !== window.top ? 'none' : 'block',
    /*
    ...(position.x !== null && position.y !== null ? {
      left: `${position.x}px`,
      top: `${position.y}px`,
      right: 'auto',
      bottom: 'auto'
    } : {})
    */
  };

  return (
    <div className="sse-status-container" style={containerStyle}>
      <div
        className="sse-status-indicator"
        onClick={() => setShowDetails(!showDetails)}
        // onMouseDown={handleMouseDown}
        title={`SSE Status: ${getStatusText()}`}
      >
        <div
          className="sse-status-dot"
          style={{ backgroundColor: getStatusColor() }}
        />
        <span className="sse-status-text">{getStatusText()}</span>
      </div>

      {showDetails && (
        <div className="sse-status-details">
          <div className="sse-status-detail-row">
            <span className="label">Status:</span>
            <span className="value">{getStatusText()}</span>
          </div>
          {status.reconnectAttempts > 0 && (
            <div className="sse-status-detail-row">
              <span className="label">Reconnect Attempts:</span>
              <span className="value">{status.reconnectAttempts}</span>
            </div>
          )}
          {status.lastHeartbeat && (
            <div className="sse-status-detail-row">
              <span className="label">Last Heartbeat:</span>
              <span className="value">
                {new Date(status.lastHeartbeat).toLocaleTimeString()}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SSEConnectionStatus;
